import { useCallback, useState } from 'react';
import { useAlerts } from '../feedback';

type Status = 'success' | 'failed' | null;
type UseClipboardArgs = { successMessage?: string; errorMessage?: string };

export const useClipboard = ({ successMessage, errorMessage }: UseClipboardArgs = {}) => {
  const { showError, showSuccess } = useAlerts();
  const [status, setStatus] = useState<Status>(null);
  const reset = useCallback(() => setStatus(null), []);

  const copyText = useCallback(
    (text: string) =>
      navigator.clipboard
        .writeText(text)
        .then(() => {
          successMessage && showSuccess(successMessage);
          setStatus('success');
        })
        .catch(() => {
          errorMessage && showError(errorMessage);
          setStatus('failed');
        }),
    [showError, showSuccess, errorMessage, successMessage],
  );

  return { copyText, reset, status };
};
